module.exports = __webpack_public_path__ + "static/media/aws-logo.6ff6a5ec.png";